var _effectorFileName = "/src/shared/api/get-roadmap/api.ts";
import { withFactory as _withFactory } from "effector";
import { createQuery } from '@farfetched/core';
import { createEffect } from 'effector';
import { httpClient } from '../api';
const URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : process.env.NEXT_PUBLIC_APP_URL;
export const getDocFx = createEffect(async (docTitle: string) => {
  const response = await httpClient<Blob>(`${URL}/api/quiz?doc=${docTitle}`, {
    isBlob: true,
    method: 'GET'
  });

  // Создаем новый blob с правильным MIME-типом для принудительного скачивания
  const blob = new Blob([response], {
    type: 'application/octet-stream'
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `enlerno-${docTitle}.pdf`;

  // Добавляем атрибуты для принудительного скачивания
  link.setAttribute('download', 'enlerno-roadmap.pdf');
  link.style.display = 'none';

  // Добавляем обработчик для принудительного скачивания
  link.addEventListener('click', e => {
    e.preventDefault();
    const downloadUrl = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.href = downloadUrl;
    tempLink.download = `enlerno-${docTitle}.pdf`;
    tempLink.style.display = 'none';
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(downloadUrl);
  });
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  return response;
}, {
  loc: {
    file: _effectorFileName,
    line: 8,
    column: 24
  },
  name: "getDocFx",
  sid: "wtl6k8"
});
export const getRoadmapQuery = _withFactory({
  sid: "vo0pma",
  fn: () => createQuery({
    handler: getDocFx
  }),
  name: "getRoadmapQuery",
  method: "createQuery",
  loc: {
    file: _effectorFileName,
    line: 53,
    column: 31
  }
});